/**
 * Esportazione CSV lato client.
 *
 * Non passa da un endpoint: un `<a href>` diretto non attraverserebbe l'interceptor che inietta il
 * Bearer, e i dati del riepilogo sono già in memoria. Punto d'arrivo atteso: Excel italiano, che
 * apre senza wizard solo con separatore `;`, BOM e decimali con la virgola.
 */

const BOM = '﻿';

/**
 * Caratteri iniziali che un foglio di calcolo interpreta come formula: davanti alla cella di testo
 * va un apostrofo (DEC-17 Fase 5). Gli stessi dodici di `CsvCellEscaper.TRIGGERS` (backend, core).
 */
export const CSV_FORMULA_TRIGGERS = [
  '=', '+', '-', '@', "'", '\t', '\r', '\n', '＝', '＋', '－', '＠',
];

const escapeCell = (value, delimiter) => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  const text =
    typeof value === 'string' && CSV_FORMULA_TRIGGERS.includes(value[0]) ? `'${raw}` : raw;
  return /["\r\n]/.test(text) || text.includes(delimiter)
    ? `"${text.replace(/"/g, '""')}"`
    : text;
};

/**
 * @param rows righe di dati
 * @param columns [{ header, value: (row) => string|number }]
 * @param options.delimiter separatore (default ';')
 * @param options.preamble righe libere da anteporre (periodo, confronto)
 */
export const toCsvString = (rows, columns, options = {}) => {
  const delimiter = options.delimiter ?? ';';
  const lines = [];

  (options.preamble ?? []).forEach((line) => {
    lines.push(line.map((cell) => escapeCell(cell, delimiter)).join(delimiter));
  });

  lines.push(columns.map((column) => escapeCell(column.header, delimiter)).join(delimiter));

  rows.forEach((row) => {
    lines.push(columns.map((column) => escapeCell(column.value(row), delimiter)).join(delimiter));
  });

  return lines.join('\r\n');
};

/** Scarica il CSV come file locale: nulla lascia il browser. */
export const downloadCsv = (filename, csv) => {
  const blob = new Blob([BOM, csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
